import { Pipe, PipeTransform } from '@angular/core';
/**
 * ReversePipe returns a shallow reversed copy of an array-like value.
 *
 * It calls `slice().reverse()` to avoid mutating the original array.
 *
 * Template usage:
 *```html
 *   @for (item of (items | reverse); track item.id) {
 *       <div>{{ item.name }}</div>
 *   }
 * ```
 */
@Pipe({ name: 'reverse', standalone: true })
export class ReversePipe implements PipeTransform {
    /**
     * Return a new array with items in reverse order.
     *
     * @param value Array-like value.
     * @returns Shallow reversed copy; original is not changed.
     */
    transform(value) {
        return value.slice().reverse();
    }
}
